import React from 'react';
import { Button } from '@mui/material';

const WorkflowButtonSecondary = ({
  variant = 'outlined',
  text,
  'data-test-id': dataTestId,
  startIcon,
  ...rest
}) => {

  return (
    <Button
      variant={variant}
      data-test-id={dataTestId}
      sx={{
        minHeight: '27px',
        height: '27px',
      }}
      {...rest}
    >
      {startIcon && startIcon}
      {text}
    </Button>
  );
};

export default WorkflowButtonSecondary;
